import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useSetImmediateResponse = () =>
  apiClient.customsSimulator.setBatchImmediateResponse.useMutation({
    onError: (error) => {
      showErrorToast(error, 'Error setting immediate response');
    },
  });
